module.exports = __webpack_public_path__ + "static/media/placeholder-person.5447919d.png";